/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Gallery from 'react-grid-gallery';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Breadcrumb from '../../../components/Breadcrumb';
import Sidebar from '../../../components/Sidebar/AboutUs';
import s from '../AboutUs.css';

class CompanyProfile extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string.isRequired,
        thumbnail: PropTypes.string.isRequired,
        srcset: PropTypes.array,
        caption: PropTypes.string,
        thumbnailWidth: PropTypes.number,
        thumbnailHeight: PropTypes.number,
        isSelected: PropTypes.bool,
      }),
    ).isRequired,
  };

  static defaultProps = {
    images: [
      {
        src: '/images/factory_front.png',
        thumbnail: '/images/factory_front.png',
        thumbnailWidth: 1028,
        thumbnailHeight: 494,
        caption: 'Maybricks Sdn Bhd',
        thumbnailCaption: 'Maybricks Sdn Bhd',
      },
    ],
  };

  constructor(props) {
    super(props);

    this.state = {
      images: this.props.images,
    };
  }

  render() {
    return (
      <div className={s.root}>
        <Breadcrumb title={this.props.title} />
        <div className={s.container}>
          <Sidebar title={this.props.title} />
          <div className={s.contents}>
            <h1>
              {this.props.title}
            </h1>
            <div className={s.gallery}>
              <Gallery
                images={this.state.images}
                backdropClosesModal
                enableImageSelection={false}
                rowHeight={494}
              />
            </div>
            <p>
              Maybricks Sdn Bhd is one of the Asia&apos;s leading brick
              manufacturers specialising in producing high quality construction
              clay materials: common solid bricks, common blocks, facing bricks,
              clay pavers and brick tiles. With its headquarter based in Kulai,
              Johor; Maybricks is supported by workforce of over 150 people with
              2 production plants running 24 hours a day; 7 days a week.
            </p>
            <p>
              Founded in 1972 as Federal Bricks Industries, it was later renamed
              Maybricks Sdn Bhd. in 1989. Since incorporation, though Maybricks
              was one of the very few pioneers in clay bricks manufacturing, its
              focus on quality and total customer satisfaction has remained
              consistent until today.
            </p>
            <p>
              Over the past 40 years, Maybricks invests in only top of the range
              German technology and machineries. Its uncompromising diligence in
              R&amp;D has fast-forwarded Maybricks into the next milestone of
              efficiency – attaining the production capacity of 300,000 pieces
              of common unit per day.
            </p>
            <p>
              Maybricks&apos; carefully-built reputation has been well
              acknowledged by regional industrial players and was awarded ISO
              9001:2015 since 2006 and was certified by SIRIM since 2015. Today,
              Maybricks clay products are being widely exported to Australia,
              Taiwan, Middle East, Europe and even countries with extremely
              stringent requirements such as Japan and Singapore, which
              contributes more than 45% of the total Maybricks sales.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(CompanyProfile);



// WEBPACK FOOTER //
// ./src/routes/about-us/company-profile/CompanyProfile.js